const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question24-container");
const questionElement = document.getElementById("question24");
const answerButtonsElement = document.getElementById("answer-buttons24");
const ctaElement = document.getElementById("cta24");


const questions24 = [
  {
    question:
      "How often do you measure sales and marketing plans?",
    answers: [
      { text: "Every day", correct: true },
      { text: "Every week", correct: true },
      { text: "Once a month", correct: true },
      { text: "Don’t measure", correct: true },
    ],
  },
  {
    question: "What do you use to track campaign metrics?",
    answers: [
      { text: "Online Platform", correct: true },
      { text: "Offline Means (Hardcopy)", correct: true },
      { text: "Software, not online", correct: true },
      { text: "Don’t have one", correct: true },
    ],
  },
  {
    question: "What do you need help with?",
    answers: [
      { text: "Improving the ability to track campaign analytics", correct: true },
      { text: "Using a platform from anywhere in the world which automatically updates campaign success", correct: true },
    ],
  },
];


let shuffledQuestions24, currentQuestionIndex24;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex24++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions24 = questions24.sort();
  // () => Math.random() - 0.5;
  currentQuestionIndex24 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex24 > questions24.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions24[currentQuestionIndex24]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Fantastic! DYL’s Call Whispering feature is accompanied by unlimited call recording and activity reports, so management can see if an employee is accurately answering a client’s or prospect’s questions. They can also take advantage of the whisper function to train Sales staff, putting them one step closer to the sale.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}

function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}


function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/businessman-overwhelmed-with-stacks-of-paper.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/daschund-relaxing-with-cucumbers-on-eyes.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",
  ];
function rotateGallery() {
  document.getElementById("ImgGalleryCWQ").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

